import { render } from "./PatreonButton.vue?vue&type=template&id=dfdf1db8&scoped=true&bindings={}"
import script from "./PatreonButton.vue?vue&type=script&lang=ts"
export * from "./PatreonButton.vue?vue&type=script&lang=ts"

import "./PatreonButton.vue?vue&type=style&index=0&id=dfdf1db8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dfdf1db8"

export default script